import { useEffect, useState, forwardRef, useImperativeHandle } from 'react';
import { Table /*Tooltip*/ } from 'antd';
import { Link } from 'react-router-dom';
import useOrder from '&/utils/customHooks/useOrder';
import InvoicingModal from '&/pages/order-manage/components/InvoicingModal';
import { getEntVipList } from '&/api/personCenter/orderManage';
import './index.scss';

const corporateMemberTable = forwardRef((props, ref) => {
    const { type } = props;

    const invoicingModalRef = useRef();

    const [modalType, setModalType] = useState('');
    const [invoicingData, setInvoicingData] = useState({});
    const [tableData, setTableData] = useState([]);
    const [total, setTotal] = useState(0);
    const [columns, setColumns] = useState([]);
    const [queryForm, setQueryForm] = useState({
        page: 1,
        limit: 10,
    });
    const [TABS] = useOrder({ columns: [], detailRequest: () => {} });
    const statusSet = [
        ...TABS,
        { code: '03', name: intl.get('userCenter.stale') },
    ];
    const allColumns = [
        {
            title: intl.get('base.serialNum'),
            key: '1',
            width: 60,
            render: (_, __, idx) => {
                return idx + 1;
            },
            align: 'center',
        },
        {
            title: intl.get('userCenter.orderNumber'),
            dataIndex: 'orderCode',
            align: 'left',
            render: text => (
                <Link
                    className="control-btns"
                    style={{
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                        wordBreak: 'break-all',
                        maxWidth: '100%',
                        display: 'inline-block',
                    }}
                    to={`/user-center/corporate-membership/order-detail?id=${text}&type=1`}>
                    {text}
                </Link>
            ),
            ellipsis: true,
            widthPercent: { 1: 20, 3: 20, 2: 17 },
        },
        {
            title: intl.get('userCenter.orderContent'),
            dataIndex: 'orderContent',
            widthPercent: { 1: 20, 3: 20, 2: 14 },
            align: 'left',
            ellipsis: true,
        },
        {
            title: intl.get('userCenter.commodity'),
            dataIndex: 'productName',
            align: 'left',
            include: [2, 3],
            widthPercent: { 1: 20, 3: 15, 2: 15 },
            editable: true,
            ellipsis: true,
        },
        {
            title: intl.get('userCenter.amount'),
            dataIndex: 'realMoney',
            render: money => `￥ ${money}`,
            align: 'right',
            widthPercent: { 1: 12, 3: 12, 2: 11 },
        },
        {
            title: intl.get('userCenter.orderState'),
            dataIndex: 'status',
            render: (status, record) => {
                const res = [statusSet.find(e => e.code === status)?.name];
                /*if (status === '01') {
                    res.push(
                        <>
                            <Tooltip
                                placement="top"
                                title={intl.get('userCenter.lastPayTime', {
                                    time: record.payDeadline,
                                })}>
                                <i className="filled icon-question-cirlce1"></i>
                            </Tooltip>
                        </>
                    );
                }*/
                return res;
            },
            align: 'center',
            widthPercent: { 1: 12, 3: 12, 2: 9 },
        },
        {
            title: intl.get('userCenter.bill'),
            dataIndex: 'billingFlag',
            align: 'center',
            render: (val, record) => {
                const flagSet = [
                    <div className="invoice-unissued">
                        {intl.get('userCenter.billNotIssue')}
                        {/*<Tooltip placement="top" title={record.billingDeadline}>
                            <i className="filled icon-question-cirlce1" />
                        </Tooltip>*/}
                    </div>,
                    <div className="invoice-unissued">
                        {intl.get('userCenter.billIssued')}
                    </div>,
                    <div className="invoice-overdue">
                        {intl.get('userCenter.stale')}
                    </div>,
                    <div className="invoice-overdue">待开票</div>,
                ];
                return record.status === '02' && flagSet[val];
            },
            width: 88,
        },
        {
            title: intl.get('userCenter.orderTime'),
            dataIndex: 'orderTime',
            align: 'center',
            widthPercent: { 1: 15, 3: 15, 2: 14 },
            ellipsis: true,
        },
        {
            title: intl.get('userCenter.memberValidity'),
            align: 'center',
            include: [1],
            render: (status, record) => {
                return `${record.effectiveDate}-${record.expireDate}`;
            },
            widthPercent: { 1: 15, 3: 15, 2: 14 },
            ellipsis: true,
        },
        {
            title: intl.get('userCenter.validTo'),
            dataIndex: 'couponExpireDate',
            align: 'center',
            include: [2],
            widthPercent: { 1: 15, 3: 15, 2: 11 },
        },
        {
            title: intl.get('base.operation'),
            key: 'operation',
            align: 'center',
            className: 'last-col',
            render: record => {
                return (
                    <div className="btn-group">
                        {['02'].includes(record.status) &&
                            record.billingFlag === 0 && (
                                <div
                                    className="control-btns"
                                    onClick={() => showInvoicingModal(record)}>
                                    {intl.get('userCenter.issueBill')}
                                </div>
                            )}
                        {(record.billingFlag === 3 ||
                            record.billingFlag === 1) && (
                            <div
                                className="control-btns"
                                onClick={() => showInvoicingModal(record)}>
                                {intl.get('userCenter.invoiceInformation')}
                            </div>
                        )}
                    </div>
                );
            },
            width: 88,
        },
    ];

    useImperativeHandle(ref, () => {
        return {};
    });

    useEffect(() => {}, []);

    useEffect(() => {
        getColumns();
        queryList();
        console.log('type', type);
    }, [type]);

    const showInvoicingModal = data => {
        if (data.billingFlag === 0) {
            setModalType('save');
        } else {
            setModalType('details');
        }
        setInvoicingData(data);
        invoicingModalRef.current.show();
    };

    const getPercent = (item, type, total) => {
        return ((1319 - total) / 1319) * item.widthPercent[type] + '%';
    };

    const getColumns = () => {
        const list = allColumns
            .filter(item => {
                if (!item.include) {
                    return true;
                } else {
                    return item.include.includes(Number(type));
                }
            })
            .map(item => {
                if (item.widthPercent) {
                    item.width = getPercent(item, type, 88 + 88 + 60);
                    console.log('item', item);
                }
                return item;
            });
        setColumns(list);
    };

    const queryList = async () => {
        try {
            const sendData = {
                ...queryForm,
                type,
            };
            const res = await getEntVipList(sendData);
            setTableData(res.data.list);
            setTotal(res.data.total);
        } catch (e) {}
    };
    const changePage = page => {
        setQueryForm({ page, limit: 10 });
    };

    return (
        <div className="corporate-member-table">
            <Table
                columns={columns}
                dataSource={tableData}
                bordered
                pagination={{
                    size: 'small',
                    current: queryForm.page,
                    onChange: changePage,
                    total: total,
                    showSizeChanger: false,
                    showTotal: total =>
                        intl.get('rendering.totalNum', { total }),
                }}
            />
            <InvoicingModal
                ref={invoicingModalRef}
                invoicingData={invoicingData}
                modalType={modalType}
                refreshData={queryList}
            />
        </div>
    );
});

export default corporateMemberTable;
